/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState } from 'react';
import ThemeContext from 'contexts/ThemeContext';
import IconButton from '@material-ui/core/IconButton';
import api from 'api';

import { SideMenu, SectionTitle, Input, Button } from 'components';
import { Container, ContentArea, TitleArea } from './styles';
import { toast } from 'react-toastify';
import { BsArrowLeft } from 'react-icons/bs';

function Create({ history }) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const { primary } = useContext(ThemeContext);

  const handleCreateObjectType = async () => {
    setLoading(true);
    try {
      await api.post('/checklist', {
        question: data?.question,
      });
      setLoading(false);
      history.push('/checklists');
      toast.success('Checklist criado com sucesso!');
    } catch (e) {
      setLoading(false);
      toast.error(e?.response?.data?.error);
    }
  };

  return (
    <Container>
      <SideMenu />
      <ContentArea>
        <TitleArea>
          <IconButton
            style={{ maerginRight: 5 }}
            onClick={() => history?.goBack()}>
            <BsArrowLeft size={16} />
          </IconButton>
          <h1>Checklist</h1>
        </TitleArea>
        <section>
          <SectionTitle color={primary} title="Adicionar novo" />

          <div className="form">
            <Input
              height="35px"
              width="380px"
              label="Descrição"
              value={data?.question}
              onChange={(e) => setData({ ...data, question: e.target.value })}
            />

            <Button
              loading={loading}
              onClick={handleCreateObjectType}
              height="35px"
              width="380px"
              style={{ marginTop: 30 }}
              disabled={loading || !data?.question}>
              Adicionar
            </Button>
          </div>
        </section>
      </ContentArea>
    </Container>
  );
}

export default Create;
